<template>
  <div class="order-summary">
    <h3 class="title is-4 has-text-grey">
      {{ $t("orderDetails.labels.summary") }}
    </h3>
    <div class="summary__list">
      <div class="summary__entry">
        <span class="entry__label">{{
          $t("checkout.paymentDetails.paymentMethod")
        }}</span
        ><span class="entry__value">{{
          $t(
            `checkout.paymentMethodLabels.${paymentDetails.billingPaymentMethod}`
          )
        }}</span>
      </div>
      <div class="summary__entry">
        <span class="entry__label">{{$t("checkout.productionTime")}}</span
        ><span class="entry__value">
          <template v-if="cumulatedProductionTime > 0">
            {{ $tc("checkout.productionTimeDays", getMaagtechnicProductionTime) }}
          </template>
          <template v-else>--</template>
        </span>
      </div>
      <div class="summary__entry">
        <span class="entry__label">{{$t("checkout.totalShippingTime")}}</span
        ><span class="entry__value"
          ><template v-if="cumulatedProductionTime > 0"
            >{{
              $tc(
                "checkout.productionTimeDays",
                shippingMethod.shippingTimeDays
              )
            }}
          </template>
          <template v-else>--</template></span
        >
      </div>
      <div class="summary__entry">
        <span class="entry__label">{{$t("checkout.totalDeliveryTime")}}</span>
        <template v-if="cumulatedProductionTime > 0">
          <strong class="entry__value">
            {{
              $tc(
                "checkout.productionTimeDays",
                shippingMethod.shippingTimeDays + getMaagtechnicProductionTime
              )
            }}
          </strong>
        </template>
        <template v-else><span class="entry__value">--</span></template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "OrderSummary",
  computed: {
    ...mapGetters([
      "paymentDetails",
      "availablePaymentMethods",
      "allCartItems",
      "positionPrice",
      "cumulatedProductionTime",
    ]),
    chosenPaymentMethod() {
      if (this.paymentDetails) {
        return this.paymentDetails.billingPaymentMethod;
      } else {
        return "";
      }
    },
    shippingMethod() {
      return this.$store.getters
        .shippingCountryById(this.paymentDetails.shippingAddress.countryId)
        .shippingMethods.find(
          (method) =>
            method.shippingMethodId === this.paymentDetails.shippingMethodId
        );
    },
    getMaagtechnicProductionTime() {
      const estimatedProductionTimesByWeekday = {
          0: 9, // Sunday
          1: 8, // Monday
          2: 7, //...
          3: 6,
          4: 5,
          5: 4,
          6: 9, //Saturday
      };

      return estimatedProductionTimesByWeekday[new Date().getDay()];
   },
  },
};
</script>

<style scoped lang="scss">
strong.entry__value {
  font-weight: normal;
  font-family: GeomanistBold, Helvetica, Arial, sans-serif;
}
</style>
